import { Component, input } from '@angular/core';
import { AsyncPipe } from '@angular/common';
import { interval, map, startWith } from 'rxjs';


@Component({
  selector: 'app-animated-loading',
  standalone: true,
  imports: [
    AsyncPipe
  ],
  templateUrl: './animated-loading.component.html'
})
export class AnimatedLoadingComponent {
  phrases = ['Generando la risposta', 'Analizzando i dati', 'Sto pensando'];

  genText$ = interval(3500).pipe(
    startWith(0), 
    map(index => this.phrases[index % this.phrases.length])
  );
}
